<template>
  <div class="box9">
   <img src="../../../assets/coursePage/trainer/09.png"/>
  </div>
</template>

<script>


export default {
 
  data() {
    return {
 
    };
  },
};
</script>

<style lang="less" scoped>
.box9{
  width: 100%;
 img{
  width: 100%;
  display: block;
 }
  
}
</style>
